/* eslint-disable max-len */
import React,{useEffect,useState,useRef, useContext, useCallback} from 'react'
import { useSelector } from 'react-redux';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import GlobalContext from '../../Context/GloablContext';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { dataService } from '../../../services/data.services';
import SearchShimmer from '../../Shimmer/SearchShimmer';
import AnimatedModel from '../../Animation/AnimatedModel';
import ConfirmationPrompt from '../../ConfirmationPrompt';
import { ShimmerTitle } from 'react-shimmer-effects';

export default function SideBarBranchModal({handleVerify,swithFY, selectedOngoingFY, branches}) {
    const [selectedBranch, setselectedBranch] = useState({});
    const {isSideNavBar, setswithBranch, setswithFY, setToastErrorMessage,UpdateCall,  setUpdateCall}=useContext(GlobalContext)
    const [FYPopup, setFYPopup] = useState(false)
    const [FYList, setFYList] = useState([]);
    const [loadingFY, setLoadingFY] = useState(true)
    const [selectedFYObject, setSelectedFYObject] = useState({})
    const getFY = useCallback(async () => {
        const branch_id = await GetBranchId();
        try {
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing,open`);
            setFYList(res?.data?.data?.financial_years)
            setLoadingFY(false);

        } catch (error) {
            // Handle the error here
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error('An error occurred:', error);
        }
    }, []);

    useEffect(() => {
        if(swithFY) {
            getFY()
        } else {
            if(Object.keys(selectedBranch)?.length===0){
                setselectedBranch(JSON.parse(localStorage.getItem('branch_details')))
            }
        }
    }, [getFY])
    const ref = useRef(null);
    useOnClickOutside(ref,()=>{
        setswithBranch(false)
        if(!FYPopup) {
            setswithFY(false)
        }
    })
    const [loadingButton, setLoadingButton] = useState(false)
    
    const handelConFormation = async() => {
        setLoadingButton(true)
        setTimeout(() => {
            handleVerify(selectedFYObject,swithFY)
            setLoadingButton(false)
            setFYPopup(false)
            setswithFY(false)    
        }, 500);
      
    }
    /**
     * The function `handelChangeStatusButton` toggles the value of `changeStatusButton`.
     */
    const handelChangeStatusButton = () => {
        setFYPopup(!FYPopup)
    }

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setIsLoading(false), 2000);
        return () => clearTimeout(timer); // Clean up the timer
    }, []);
    
    return (
        <>
            {(swithFY ? (FYList?.length > 1 || loadingFY) : branches?.length > 1) && <div>
                <div ref ={ref} class={`border border-[#C2DCEF] rounded p-3 fixed top-[85px] bg-[#FFFFFF] shadow-s10 w-[352px] z-[999] switch_btw_branches `} style={{left:isSideNavBar?'93px':'282px',top:'77px'}}>
                    <div class="border border-lg bg-[#EEF7FE] px-[11px] py-[7px] rounded">
                        <h5 class="pb-[4px]">Current {swithFY ? "Financial Year" : "Branch"}</h5>
                        { isLoading 
                            ? <p class="py-[3.5px]"><ShimmerTitle line={1} gap={0} variant="secondary" className="w-full mb-0"/></p>
                            :<p class="font-semibold text-[#031624]">{swithFY ? (JSON.parse(localStorage.getItem('FY_details')) !== null ? `${JSON.parse(localStorage.getItem('FY_details'))?.name} (${JSON.parse(localStorage.getItem('FY_details'))?.status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details'))?.status.slice(1)})` : `${selectedOngoingFY?.name} (${selectedOngoingFY?.status.charAt(0).toUpperCase() + selectedOngoingFY?.status.slice(1)})`) : `${selectedBranch?.branchNameWithStatus!=undefined?selectedBranch?.branchNameWithStatus:selectedBranch?.name}`}</p>
                        }
                    </div>
                    {<div class="mt-5">
                        <p class=" mb-1">{swithFY ? "All Financial Years" : "Accessible Branches"}</p>
                        <div class="border border-[#D0D5DDD0] rounded error_border">

                            <ul class="h-[110px] overflow-y-auto scroll-smooth scroll-bar px-1 mr-1 mt-1 cursor-pointer">
                                {swithFY ?
                                    (loadingFY ? <SearchShimmer count={3} height={'100px'}/> : FYList.map((branch,i)=>(
                                        branch.name !== (JSON.parse(localStorage.getItem('FY_details')) !== null ? JSON.parse(localStorage.getItem('FY_details')).name : selectedBranch.name)&&
                                        <li key={i} onClick={()=> {handelChangeStatusButton(); setSelectedFYObject(branch)}}>
                                            <a href="javascript:void(0)" class="slct_drp_dwn_optn" 
                                                title={`${branch.name} (${branch?.status.charAt(0).toUpperCase() + branch?.status.slice(1)})`} >
                                                {`${branch.name} (${branch?.status.charAt(0).toUpperCase() + branch?.status.slice(1)})`} 
                                            </a>
                                        </li>
                                    )))
                                    :
                                    branches.filter((val)=>val.id!==selectedBranch.id).map((branch,i)=>(
                                        <li key={i} onClick={()=> {
                                            handleVerify(branch,swithFY)
                                            setUpdateCall(!UpdateCall)
                                        }
                                        }>
                                            {/*fix here after API change-Anitha-1*/}
                                            {branch.status !== undefined ? (
                                                <a
                                                    href="javascript:void(0)"
                                                    title={branch.name}
                                                    className={`slct_drp_dwn_optn ${branch.status ? '' : 'disabled'}`}>
                                                    {branch.name} {branch.status ? "" : "(Inactive)"}
                                                </a>
                                            ) : (
                                                <a
                                                    href="javascript:void(0)"
                                                    title={branch.name}
                                                    class="slct_drp_dwn_optn">
                                                    {branch.name}
                                                </a>
                                            )}
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>}
                </div> 
                {FYPopup && <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handelConFormation}
                            handleClose={handelChangeStatusButton}
                            tittle={"Switch FY"}
                            message={
                                `Are you sure you want to switch the current Financial Year to '${selectedFYObject.name}' ?`
                            }
                            buttonName="Switch"
                            loadingActivation={loadingButton}
                        />
                    }
                />}
            </div>}
        </>
    )
}
